/* product/showLastSeen
 ========================================================================== */
import lastSeen from './lastSeen';
import addLazyLoad from '../lazyLoad';
/**
 * @param lastSeenComponent
 * @param site
 * @param currentProductHash
 */
function show(lastSeenComponent, site, currentProductHash = null) {
    const lastSeenWrapper = lastSeenComponent.querySelector('ul');
    let lastSeenProducts = lastSeen.get(site);
    // don't show current product in lastSeen tab
    if (currentProductHash) {
        lastSeenProducts = lastSeenProducts.filter(current => currentProductHash !== current.hash);
    }
    // max 3 elements per lastSeen tab
    lastSeenProducts = lastSeenProducts.slice(0, 3);
    if (lastSeenProducts.length > 0) {
        lastSeenProducts.forEach((current) => {
            lastSeenWrapper.insertAdjacentHTML('beforeend', `<li class="c-slider__item">${current.template}</li>`);
        });
    }
    else {
        // Hide both tab and panel when no last seen products
        const tabsComponent = document.querySelector('[data-component="cross-selling"]');
        const lastSeenTab = tabsComponent.querySelector('#tab-more-products-last');
        lastSeenComponent.remove();
        lastSeenTab.remove();
        // If this was the only tab, hide the entire tabs container
        if (tabsComponent.querySelectorAll('.c-tabs__item').length === 0) {
            tabsComponent.remove();
        }
    }
}
export default function showLastSeenProducts() {
    const lastSeenComponent = document.querySelector('[data-component="lastseen"]');
    if (lastSeenComponent && !lastSeenComponent.dataset.initialized && lastSeenComponent.querySelector('ul')) {
        lastSeenComponent.dataset.initialized = 'true';
        const cartComponent = document.querySelector('[data-component="cart"]');
        const productComponent = document.querySelector('[data-component="product"]');
        if (cartComponent && cartComponent.dataset.site) {
            show(lastSeenComponent, cartComponent.dataset.site);
        }
        else if (productComponent && productComponent.dataset.site && productComponent.dataset.productHash) {
            show(lastSeenComponent, productComponent.dataset.site, productComponent.dataset.productHash);
        }
        else if (productComponent && productComponent.dataset.site) {
            show(lastSeenComponent, productComponent.dataset.site);
        }
        setTimeout(addLazyLoad, 0);
    }
}
